import React, { Suspense } from 'react';
import { Route, HashRouter, Routes as Switch } from 'react-router-dom';

import { NativeRedirectInvalidation } from '@/domain/app';
import { AddToGoogleWalletPage, GoogleWalletPage } from '@/pages';
import { ComingSoonPage } from '@/pages/ComingSoon';
import ScrollToTop from '@/utils/ScrollToTop';

import useText from '@hooks/use-text';
import BlockReorderKb from '@pages/block-reorder-kb/BlockReorderKb';
import HardBlockCardConfirmPageV3 from '@pages/block-reorder/confirm/HardBlockConfirmPage';
import SoftBlockCardConfirmPage from '@pages/block-reorder/confirm/SoftBlockConfirmPage';
import NewPinEntryPage from '@pages/block-reorder/new-pin-entry/NewPinEntryPage';
import PinChangeDecisionPage from '@pages/block-reorder/pin-change-decision/PinChangeDecisionPage';
import SelectBlockTypePage from '@pages/block-reorder/select-block-type/SelectBlockTypePage';
import SelectReasonPage from '@pages/block-reorder/select-reason/SelectReasonPage';
import SelectReorderCardPage from '@pages/block-reorder/select-reorder/SelectReorderPage';
import { CardDetailsPage } from '@pages/card-details/CardDetailsPage';
import CardRulesPage from '@pages/card-rules/CardRulesPage';
import Click2PayOnboarding from '@pages/click2pay/Click2PayOnboarding';
import CloseCreditAccountTransferPage from '@pages/close-credit-account/CloseCreditAccountTransferPage';
import ComplaintPage from '@pages/complaint/ComplaintPage';
import ContactInfoPage from '@pages/contact-info/ContactInfoPage';
import UpdateContactInfoPage from '@pages/contact-info/UpdateContactInfoPage';
import MyCardsPage from '@pages/my-cards/MyCardsPage';
import OrderCardPage from '@pages/order-card/OrderCardPage';
import OrderCardSigningResultPage from '@pages/order-card/signing-result/OrderCardSigningResultPage';
import SpendingLimitsPage from '@pages/spending-limits/SpendingLimitsPage';
import { TransactionsPage } from '@pages/transactions/TransactionsPage';
import VisaFxSimpleCalculatorPage from '@pages/visa-fx-simple-calculator/VisaFxSimpleCalculatorPage';

import { AppLoader } from './loader/Loader';
import { paths } from './routes';

export const V3App = () => {
    const { loadingPage } = useText();

    return (
        <Suspense fallback={<AppLoader title={loadingPage} />}>
            <HashRouter>
                <ScrollToTop />
                <Switch>
                    <Route path={`${paths.HOME_PAGE.path}`} element={<MyCardsPage />} />
                    <Route path={`${paths.CARD_PAGE.path}`} element={<CardDetailsPage />} />

                    <Route path={paths.CARD_TRANSACTION_PAGE.path} element={<TransactionsPage />} />

                    <Route path={paths.COMPLAINT_PAGE.path} element={<ComplaintPage />} />

                    <Route path={paths.SPENDING_LIMITS_PAGE.path} element={<SpendingLimitsPage />} />
                    {/* it was value-program before, should it ? */}

                    <Route path={paths.CARD_RULES_PAGE.path} element={<CardRulesPage />} />
                    <Route path={paths.CURRENCY_CALCULATOR_PAGE.path} element={<VisaFxSimpleCalculatorPage />} />
                    <Route path={paths.SELECT_BLOCK_TYPE_PAGE.path} element={<SelectBlockTypePage />} />
                    <Route path={paths.SOFT_BLOCK_CARD_CONFIRM_PAGE.path} element={<SoftBlockCardConfirmPage />} />
                    <Route path={paths.SELECT_REASON_PAGE.path} element={<SelectReasonPage />} />
                    <Route path={paths.SELECT_REORDER_CARD_PAGE.path} element={<SelectReorderCardPage />} />
                    <Route path={paths.PIN_CHANGE_DECISION_PAGE.path} element={<PinChangeDecisionPage />} />
                    <Route path={paths.NEW_PIN_ENTRY_PAGE.path} element={<NewPinEntryPage />} />
                    <Route path={paths.HARD_BLOCK_CARD_CONFIRM_PAGE.path} element={<HardBlockCardConfirmPageV3 />} />
                    <Route
                        path={paths.HARD_BLOCK_CARD_CONFIRM_SUMMARY_PAGE.path}
                        element={<HardBlockCardConfirmPageV3 />}
                    />
                    <Route path={`${paths.ORDER_CARD_PAGE.path}/*`} element={<OrderCardPage />} />
                    <Route path={`${paths.ORDER_CARD_PAGE_RESULT.path}/*`} element={<OrderCardSigningResultPage />} />
                    <Route path={paths.SELECT_BLOCK_REORDER_PAGE.path} element={<BlockReorderKb />} />

                    <Route
                        path={`${paths.CLOSE_CREDIT_ACCOUNT_TRANSFER_FORM_PAGE.path}/*`}
                        element={<CloseCreditAccountTransferPage />}
                    />
                    <Route path={paths.CARD_CONTACT_INFO_PAGE.path} element={<ContactInfoPage />} />
                    <Route path={paths.CARD_UPDATE_CONTACT_INFO_PAGE.path} element={<UpdateContactInfoPage />} />
                    <Route path={paths.GOOGLE_WALLET.path} element={<GoogleWalletPage />} />
                    <Route path={paths.ADD_TO_GOOGLE_WALLET.path} element={<AddToGoogleWalletPage />} />
                    <Route path={`${paths.CLICK_TO_PAY.path}/*`} element={<Click2PayOnboarding />} />
                    <Route path={paths.COMING_SOON_PATH.path} element={<ComingSoonPage />} />
                </Switch>
                <NativeRedirectInvalidation />
            </HashRouter>
        </Suspense>
    );
};
